module.exports = __webpack_public_path__ + "static/img/abort_back5.0edcd38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/abort_back5.png
// module id = /2uo
// module chunks = 0